import "@fontsource-variable/manrope";
import "@fontsource-variable/inter";
import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { ReactFlowProvider } from "@xyflow/react";
import BoardEditor from "./board_editor/BoardEditor";
import { trackBoardEvent } from "./analytics";
import "./board_editor.css";

const sentryDsn = document.querySelector('meta[name="sentry-dsn"]')?.content;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
  });
}

let currentRoot = null;

document.addEventListener("turbo:load", () => {
  if (currentRoot) {
    currentRoot.unmount();
    currentRoot = null;
  }

  const container = document.getElementById("board-editor");
  if (container) {
    const props = {
      authenticated: container.dataset.authenticated === "true",
      csrfToken: container.dataset.csrfToken || null,
      maxSavedRigs: parseInt(container.dataset.maxSavedRigs, 10) || 2,
      currentRigCount: parseInt(container.dataset.currentRigCount, 10) || 0,
      isAdmin: container.dataset.admin === "true",
      readOnly: container.dataset.readOnly === "true",
      initialState: container.dataset.initialState
        ? JSON.parse(container.dataset.initialState)
        : null,
      initialPartsList: container.dataset.partsList
        ? JSON.parse(container.dataset.partsList)
        : null,
      trackEvent: trackBoardEvent,
      devMode: container.dataset.devMode === "true",
    };

    currentRoot = createRoot(container);
    currentRoot.render(
      React.createElement(Sentry.ErrorBoundary, { fallback: React.createElement("p", null, "Something went wrong. Please refresh the page.") },
        React.createElement(ReactFlowProvider, null,
          React.createElement(BoardEditor, props)
        )
      )
    );
  }
});
